import EmailVerificationPage from './EmailVerificationPage';

export default EmailVerificationPage;
